export default {
	langdisplay(state){ return state.langdisplay; },
	access_display(state){ return state.display; },
	lateral(state){ return state.lateralShow; },
	get_displayEdit(state){ return state.displayEdit;},	
}
